import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => (
  <footer className="bg-[#2f5c96] text-white py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Indigo Beans Rooms" className="h-20 w-auto brightness-0 invert" />
          </div>
          <p className="text-sm text-blue-100 leading-relaxed">
            Connecting students, agents, and landlords for seamless accommodation booking and management.
          </p>
        </div>
        <div>
          <h3 className="text-white font-bold text-lg mb-6">Platform</h3>
          <ul className="space-y-3 text-sm text-blue-100">
            <li><Link to="/browse" className="hover:text-white hover:underline decoration-[#c19cca]">Browse Listings</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white hover:underline decoration-[#c19cca]">How It Works</Link></li>
            <li><Link to="/pricing" className="hover:text-white hover:underline decoration-[#c19cca]">Pricing</Link></li>
            <li><Link to="/sitemap" className="hover:text-white hover:underline decoration-[#c19cca]">Site Map</Link></li>
            <li><Link to="/terms" className="hover:text-white hover:underline decoration-[#c19cca]">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-white hover:underline decoration-[#c19cca]">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-bold text-lg mb-6">Support</h3>
          <ul className="space-y-3 text-sm text-blue-100">
            <li><Link to="/contact" className="hover:text-white hover:underline decoration-[#c19cca]">Help Center</Link></li>
            <li><Link to="/contact" className="hover:text-white hover:underline decoration-[#c19cca]">Contact Us</Link></li>
            <li className="pt-2 flex items-center gap-2 text-white font-medium">
              <span>📞 010 822 7138</span>
            </li>
            <li><Link to="/refund-policy" className="hover:text-white hover:underline decoration-[#c19cca]">Refund Policy</Link></li>
            <li><Link to="/popi-compliance" className="hover:text-white hover:underline decoration-[#c19cca]">POPI Act Compliance</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white hover:underline decoration-[#c19cca]">Cookie Policy</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-bold text-lg mb-6">Access</h3>
          <ul className="space-y-3 text-sm text-blue-100">
            <li><Link to="/login" className="hover:text-white hover:underline decoration-[#c19cca]">Student Login</Link></li>
            <li><Link to="/login" className="hover:text-white hover:underline decoration-[#c19cca]">Agent Login</Link></li>
            <li><Link to="/login" className="hover:text-white hover:underline decoration-[#c19cca]">Landlord Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-blue-400/30 text-center text-sm text-blue-200 flex flex-col items-center gap-2">
        <span>&copy; {new Date().getFullYear()} Indigo Beans Rooms. All rights reserved.</span>
        <span className="text-xs text-blue-300">Indigo Beans Property Group is registered with the PPRA</span>
        <span className="text-xs text-blue-300">
          Designed and developed by <a href="https://digitalnexcode.co.za" target="_blank" rel="noopener noreferrer" className="hover:text-white hover:underline decoration-blue-300">DigitalNexCode</a>
        </span>
      </div>
    </div>
  </footer>
);